import $ from "../template/jquery"

window.loadPage = function (params) {
  const current_uid = $(".page-nav.active").attr('uid')
  const uid = Date.now() + '_' + Math.random().toString(36).slice(2);

  $.ajax({
    url: params.url,
    dataType: 'script',
    headers: { 'Accept': 'text/javascript' },
    beforeSend: function(){
      if (params.page_replace){
        Notiflix.Block.standard(`.tab-pane[uid='${current_uid}'] .dentalkoo-container`)
      } else {
        $('#page-nav').append(`
          <div class="nav-link page-nav" data-bs-toggle="tab" data-bs-target="#nav-${params.url}-----${uid}" type="button" role="tab" aria-selected="false" uid="${uid}">
            <span>${params.title}</span>
            <button type="button" class="page-nav-refresh">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
            <button type="button" class="page-nav-close">x</button>
          </div>
        `)

        $('#page-nav-content').append(`
          <div class="tab-pane fade" id="nav-${params.url}-----${uid}" role="tabpanel" tabindex="0" uid="${uid}">
            <div class="dentalkoo-container overflow-auto"></div>
          </div>
        `)

        $(`.page-nav[data-bs-target='#nav-${params.url}-----${uid}']`).click()
        Notiflix.Block.standard(`.tab-pane[id='nav-${params.url}-----${uid}'] .dentalkoo-container`)
      }
    },
    success: function(res){
      if (params.page_replace){
        const current_header = $(`.page-nav[uid='${current_uid}']`)
        const current_content = $(`.tab-pane[uid='${current_uid}']`)

        current_header.attr('data-bs-target', `#nav-${params.url}-----${current_uid}`)
        current_header.find("span").text(params.title)

        current_content.attr('id', `nav-${params.url}-----${current_uid}`)
        current_content.find('.dentalkoo-container').html(res)
        Notiflix.Block.remove(`.tab-pane[uid='${current_uid}'] .dentalkoo-container`)
      } else {
        $(`.tab-pane[uid='${uid}'] .dentalkoo-container`).html(res)
        Notiflix.Block.remove(`.tab-pane[uid='${uid}'] .dentalkoo-container`)
      }

      $(`.tab-pane[uid='${uid}']`).find(".dt-filter").each(function(idx, elm){
        $(elm).attr('id', uid + $(elm).attr('id'))
      })

      $(`.tab-pane[uid='${uid}']`).find(".dt-export-ss-excel").each(function(idx, elm){
        $(elm).attr('id', uid + $(elm).attr('id'))
      })

      setFlatpickr()
      setBsStepper()
    }, 
    error: function(jqXHR){
      // if (jqXHR.status == 423 || jqXHR.status == 403) {
      //   const json = JSON.parse(jqXHR.responseText)
        
      //   if (json.message) {
      //     showToast("error", "", json.message)
      //   }

      //   if (json.redirect) {
      //     loadPage(json.redirect)
      //   } else {
      //     loadPage(lastState)
      //   }
      // } else {
      //   alert ("Error: something went wrong")
      // }
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "a", function(e){
    const href = $(this).attr("href")
    if (href == undefined || href == "" || href == "javascript:void(0);" || href.charAt(0) == "#"){
      return true;
    }
    
    const target = $(this).attr("target")
    if (target != undefined && target != ""){
      return true;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    const title = $(this).attr("page_title")
    const page_replace = ($(this).attr("page_replace") || false)

    loadPage({url: href, title: title, page_replace: page_replace})
  })
})

$(document).on('click', '.page-nav-refresh', function(){
  const $dom = $(this)
  const $header = $dom.closest(".page-nav")
  const current_uid = $header.attr('uid')
  const $body = $(`.tab-pane[uid='${current_uid}']`)
  const url = $header.attr('data-bs-target').substr(1).split("-----")[0].substr(4)

  $dom.attr('disabled', 'disabled')

  $.ajax({
    url: url,
    dataType: 'script',
    headers: { 'Accept': 'text/javascript' },
    beforeSend: function(){
      Notiflix.Block.standard(`.tab-pane[uid='${current_uid}'] .dentalkoo-container`)
    },
    success: function(res){
      $body.find('.dentalkoo-container').html(res)
      setFlatpickr()
      setBsStepper()
    }, 
    error: function(jqXHR){
    },
    complete: function(){
      $dom.removeAttr('disabled')
      Notiflix.Block.remove(`.tab-pane[uid='${current_uid}'] .dentalkoo-container`)
    }
  })
})

$(document).on('mousedown', '.page-nav', function(e){
  if (e.which != 2) {
    return true;
  }

  if ($('.page-nav').length <= 1){
    return true;
  }

  const $dom = $(this)
  const $header = $dom.closest(".page-nav")
  const current_uid = $header.attr('uid')
  const $body = $(`.tab-pane[uid='${current_uid}']`)

  var $target = null

  if ($header.hasClass("active")){
    if ($header.prev().length) {
      $target = $header.prev()
    } else if ($header.next().length) {
      $target = $header.next()
    }
  }

  $header.remove()
  $body.remove()

  if ($target){
    $target.click()
  }
}); 

$(document).on('auxclick', 'a', function(e){

  if ((e.type === 'mousedown' && e.button !== 1) || (e.type === 'auxclick' && e.button !== 1)) return;

  const href = $(this).attr("href")
  if (href == undefined || href == "" || href == "javascript:void(0);" || href.charAt(0) == "#"){
    return true;
  }
  
  const target = $(this).attr("target")
  if (target != undefined && target != ""){
    return true;
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  const title = $(this).attr("page_title")
  const page_replace = (false)

  loadPage({url: href, title: title, page_replace: page_replace})
});
